import { render, staticRenderFns } from "./CMS.vue?vue&type=template&id=22e56f81&scoped=true&"
import script from "./CMS.vue?vue&type=script&lang=js&"
export * from "./CMS.vue?vue&type=script&lang=js&"
import style0 from "./CMS.vue?vue&type=style&index=0&id=22e56f81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e56f81",
  null
  
)

export default component.exports